/** Shared time/unit conversion helpers for the gateway app. */

export const convertToMs = (value, unit) => {
  const n = parseFloat(value);
  if (isNaN(n) || n <= 0) return 500;
  switch (unit) {
    case "ms": return Math.max(500, Math.round(n));
    case "s":  return Math.max(500, Math.round(n * 1000));
    case "m":  return Math.max(500, Math.round(n * 60000));
    case "h":  return Math.max(500, Math.round(n * 3600000));
    default:   return Math.max(500, Math.round(n));
  }
};

export const msToHuman = (ms) => {
  if (!ms || ms <= 0) return { value: "5", unit: "s" };
  if (ms >= 3600000 && ms % 3600000 === 0) return { value: String(ms / 3600000), unit: "h" };
  if (ms >= 60000 && ms % 60000 === 0) return { value: String(ms / 60000), unit: "m" };
  if (ms >= 1000 && ms % 1000 === 0) return { value: String(ms / 1000), unit: "s" };
  return { value: String(ms), unit: "ms" };
};

export const headersToJson = (headers) => {
  if (!headers || Object.keys(headers).length === 0) return "";
  return JSON.stringify(headers, null, 4);
};
